module.exports = __webpack_public_path__ + "assets/81093d5666d87a312704478c05642ee1.png";